export default "__VITE_ASSET__DqhzHZ$E__"